import {
  CancelResDocument,
  CancelResMutationResult,
  CancelResMutationVariables,
} from "@graphql/api";

export default async function cancelRes(resId: number): Promise<boolean> {
  const client = global.window.apolloClient;
  const mutVars: CancelResMutationVariables = { resId };
  const result: CancelResMutationResult = await client.mutate({
    mutation: CancelResDocument,
    variables: mutVars,
  });

  const response = result.data?.cancelRes;
  
  // Log error details if available (for debugging)
  if (!response?.success && response?.errorType) {
    console.error(`CancelRes failed: ${response.errorType} - ${response.message}`);
  }

  return response?.success || false;
}
